module.exports = __webpack_public_path__ + "img/vertical_4_1_9005.b900bdb9.png";